import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { Customer } from '@app/core/models/customer.model';
import { OrderCreationCustomerRole } from '@app/shared/enums/order-creation-customer-role';
import { Logger } from '@core/services/logger.service';
import { ChooseAdvertiserNavigationState } from '@shared/models/choose-advertiser-navigation-state';
import { OrderCreatorService } from '@shared/services/order-creator.service';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
	selector: 'app-choose-advertiser',
	templateUrl: './choose-advertiser.component.html',
	styleUrls: ['./choose-advertiser.component.css']
})
export class ChooseAdvertiserComponent implements OnDestroy {

	private readonly COMPONENT_NAME = "ChooseAdvertiserComponent";

	titleKey: string = "CHOOSE_ADVERTISER_PAGE.MAIN_TITLE";
	customers: Customer[] = [];

	readonly customers$ = new BehaviorSubject<Customer[] | undefined>(undefined);

	chooseAgency = false;

	private navigationState: ChooseAdvertiserNavigationState | undefined;

	private subs = new SubSink();
	constructor (
		private _router: Router,
		private _orderCreator: OrderCreatorService,
		private _logger: Logger
	) {
		this.subs.add(
			this._router.events.subscribe(event => {
				if (event instanceof NavigationEnd || event instanceof NavigationSkipped) {
					const navigation = this._router.getCurrentNavigation();
					if (navigation) {
						const state = navigation.extras.state as ChooseAdvertiserNavigationState;
						this.initComponent(state);
					}
				}
			}));
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	private initComponent(navState: ChooseAdvertiserNavigationState | undefined) {
		if (!navState) {
			this._logger.error(this.COMPONENT_NAME, "Init failed: the navigation state is empty");
			return;
		}

		this.navigationState = navState;
		this.titleKey = "";
		this.customers = [];

		if (navState.titleKey) {
			this.titleKey = navState.titleKey;
		}

		if (navState.customers && navState.customers.length > 0) {
			this.customers = navState.customers;
			this.chooseAgency = navState.role === OrderCreationCustomerRole.Agency;
			this.customers$.next(this.customers);
		}
	}

	customerSelected(customer: Customer) {
		this._orderCreator.actOnCustomerSelected(customer, this.navigationState?.role);
	}
}
